'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _numbro = require('numbro');

var _numbro2 = _interopRequireDefault(_numbro);

var _campaigns = require('../../api/campaigns');

var _icon = require('constructicon/icon');

var _icon2 = _interopRequireDefault(_icon);

var _loading = require('constructicon/loading');

var _loading2 = _interopRequireDefault(_loading);

var _metric = require('constructicon/metric');

var _metric2 = _interopRequireDefault(_metric);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TotalDistance = function (_Component) {
  _inherits(TotalDistance, _Component);

  function TotalDistance() {
    _classCallCheck(this, TotalDistance);

    var _this = _possibleConstructorReturn(this, (TotalDistance.__proto__ || Object.getPrototypeOf(TotalDistance)).call(this));

    _this.fetchData = _this.fetchData.bind(_this);
    _this.state = { status: 'fetching' };
    return _this;
  }

  _createClass(TotalDistance, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var refreshInterval = this.props.refreshInterval;

      this.fetchData();
      this.interval = refreshInterval && setInterval(this.fetchData, refreshInterval);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: 'fetchData',
    value: function fetchData() {
      var _this2 = this;

      var campaign = this.props.campaign;


      if (Array.isArray(campaign)) {
        (0, _campaigns.fetchCampaigns)({ ids: campaign }).then(function (data) {
          var total = 0;
          data.map(function (campaign) {
            total += _this2.calculateTotal(campaign);
          });

          _this2.setState({
            status: 'fetched',
            data: total
          });
        }).catch(function (error) {
          _this2.setState({ status: 'failed' });
          return Promise.reject(error);
        });
      } else {
        (0, _campaigns.fetchCampaign)(campaign).then(function (data) {
          _this2.setState({
            status: 'fetched',
            data: _this2.calculateTotal(data)
          });
        }).catch(function (error) {
          _this2.setState({ status: 'failed' });
          return Promise.reject(error);
        });
      }
    }
  }, {
    key: 'getDistanceForActivityType',
    value: function getDistanceForActivityType(overview, type) {
      var metrics = overview[type];
      return metrics ? metrics.distance_in_meters : 0;
    }
  }, {
    key: 'calculateTotal',
    value: function calculateTotal(data) {
      var _this3 = this;

      var activity = this.props.activity;

      switch (typeof activity === 'undefined' ? 'undefined' : _typeof(activity)) {
        case 'string':
          return this.getDistanceForActivityType(data.fitness_activity_overview, activity);
        case 'object':
          return activity.reduce(function (total, type) {
            return total += _this3.getDistanceForActivityType(data.fitness_activity_overview, type);
          }, 0);
        default:
          return Object.keys(data.fitness_activity_overview).reduce(function (total, type) {
            return total += data.fitness_activity_overview[type].distance_in_meters;
          }, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          icon = _props.icon,
          label = _props.label,
          metric = _props.metric;


      return _react2.default.createElement(_metric2.default, _extends({
        icon: icon,
        label: label,
        amount: this.renderAmount()
      }, metric));
    }
  }, {
    key: 'renderAmount',
    value: function renderAmount() {
      var _state = this.state,
          status = _state.status,
          data = _state.data;
      var _props2 = this.props,
          format = _props2.format,
          offset = _props2.offset,
          multiplier = _props2.multiplier,
          suffix = _props2.suffix;


      switch (status) {
        case 'fetching':
          return _react2.default.createElement(_loading2.default, null);
        case 'failed':
          return _react2.default.createElement(_icon2.default, { name: 'warning' });
        default:
          return '' + (0, _numbro2.default)((offset + data) / 1000 * multiplier).format(format) + suffix;
      }
    }
  }]);

  return TotalDistance;
}(_react.Component);

TotalDistance.propTypes = {
  /**
   * The campaign uid/s to fetch totals for
   */
  campaign: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),

  /**
   * The type of activity to get kms for
   * e.g. bike, [bike, run, walk, swim]
   */
  activity: _propTypes2.default.oneOf([_propTypes2.default.string, _propTypes2.default.array]),

  /**
   * Offset
   */
  offset: _propTypes2.default.number,

  /**
   * The amount to multiply the total by for custom conversions
   */
  multiplier: _propTypes2.default.number,

  /**
   * The label of the metric
   */
  label: _propTypes2.default.string,

  /**
   * The format of the number
   */
  format: _propTypes2.default.string,

  /**
   * The suffix to be appended
   */
  suffix: _propTypes2.default.string,

  /**
   * The icon to use
   * - String representing a constructicon icon e.g. heart
   * - Array of custom paths
   * - An element to use instead e.g. <i className='fa fa-heart' />
   */
  icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.element]),

  /**
   * Props to be passed to the Constructicon Metric component
   */
  metric: _propTypes2.default.object,

  /**
   * Interval (in milliseconds) to refresh data from API
   */
  refreshInterval: _propTypes2.default.number
};

TotalDistance.defaultProps = {
  label: 'Total Distance',
  offset: 0,
  multiplier: 1,
  format: '0,0',
  suffix: 'km'
};

exports.default = TotalDistance;


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/components/total-distance/index.js
// module id = 1358
// module chunks = 0